module.exports = __webpack_public_path__ + "img/home_icon23_2.d238af4f.png";